import { Controller } from "@hotwired/stimulus";

// Expands/collapses clamped text. The trigger is a real <button> whose
// aria-expanded reflects the state.
export default class extends Controller {
  static targets = ["content", "button"];

  toggle() {
    const expanded = this.contentTarget.classList.toggle("line-clamp-1") === false;
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", String(expanded));
    }
  }
}
